<template>
  <div
    class="max-width q-py-xl q-my-lg overflow-hidden"
    style="max-width: 1920px!important;"
  >
    <div class="row justify-center q-mb-xl q-pb-lg">
      <div
        class="text-white text-center imagesSectionTitle"
      >
        {{ $t('frontpage.imagesSection') }}
      </div>
    </div>
    <div class="row no-wrap justify-center">
      <img
        v-for="(img, ind) in images1"
        :key="ind"
        :src="img"
        :alt="`image-${ind}`"
        :height="getImages1Height"
        loading="lazy"
        width="auto"
      />
    </div>
    <div class="row no-wrap justify-center">
      <img
        v-for="(img, ind) in images2"
        :key="ind"
        :src="img"
        :alt="`image-${ind}`"
        :height="getImages2Height"
        loading="lazy"
        width="auto"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FrontpageImagesSection',

  data() {
    return {
      images1: [
        './image1.png',
        './image2.png',
        './image3.png',
        './image4.png',
        './image5.png',
      ],
      images2: [
        './image6.png',
        './image7.png',
        './image8.png',
        './image9.png',
      ],
    };
  },
  computed: {
    getImages1Height() {
      return this.$q.screen.width > 991 ? '510px' : '260px';
    },
    getImages2Height() {
      return this.$q.screen.width > 991 ? '506px' : '259px';
    },
  },
};
</script>
